var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"plugin-infopage-buttongroup-item"},[_c('ui-button-new',{attrs:{"href":_vm.url,"theme":_vm.theme,"is-new-window-needed":_vm.isNewWindowNeeded},domProps:{"textContent":_vm._s(_vm.text)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }